import { render, staticRenderFns } from "./RecomOrders.vue?vue&type=template&id=70284f58"
import script from "./RecomOrders.vue?vue&type=script&lang=js"
export * from "./RecomOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports